export default __webpack_public_path__ + "static/media/instagram.136b7a8b.svg";